export default __webpack_public_path__ + "bb915319f59c02c348a615ad483772e7.woff2";